import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Account created");
      navigate("/account");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Registration failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="register-page">
      <div className="label-mono text-cyan-400 mb-3">/ AUTH</div>
      <h1 className="text-4xl font-medium tracking-tight">Create account</h1>
      <form onSubmit={submit} className="mt-8 space-y-4">
        {[
          ["name", "Full name", "text"],
          ["email", "Email", "email"],
          ["password", "Password", "password"],
        ].map(([k, l, t]) => (
          <label key={k} className="block">
            <span className="label-mono text-slate-500">{l}</span>
            <input
              required
              type={t}
              data-testid={`register-${k}`}
              minLength={k === "password" ? 6 : undefined}
              value={form[k]}
              onChange={(e) => setForm({ ...form, [k]: e.target.value })}
              className="mt-1.5 w-full bg-transparent border border-white/10 focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500/30 outline-none px-3 h-11"
            />
          </label>
        ))}
        <button data-testid="register-submit" disabled={busy} type="submit" className="w-full bg-cyan-500 hover:bg-cyan-400 disabled:bg-slate-700 text-slate-950 font-semibold py-3">
          {busy ? "Creating account…" : "Create account"}
        </button>
      </form>
      <p className="mt-6 text-sm text-slate-400">
        Already have one? <Link to="/login" className="text-cyan-400 hover:text-cyan-300">Sign in</Link>
      </p>
    </div>
  );
}
